import request from '@/utils/request'
import qs from 'qs'

/**
 * 商品分类列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/rep/model/category/list',
		method: 'post',
		data: query || {}
	})
}

/**
 * 行业分类查询所有
 * @param query
 */
export function fetchAll() {
	return request({
		url: '/api/rep/model/category/all',
		method: 'get'
	})
}

/**
 * 保存商品分类
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/rep/model/category/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改商品分类
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/rep/model/category/update',
		method: 'post',
		data: param
	})
}

/**
 * 修改商品分类的导航栏显示
 *
 * @param param
 */
export function changeNav(param) {
	return request({
		url: '/api/rep/model/category/changeNav/' + param.id,
		method: 'post',
		data: qs.stringify(param)
	})
}

/**
 * 修改商品分类的显示
 *
 * @param param
 */
export function changeShow(param) {
	return request({
		url: '/api/rep/model/category/changeShow/' + param.id,
		method: 'post',
		data: qs.stringify(param)
	})
}

/**
 * 删除商品分类
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/rep/model/category/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个商品分类信息
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/rep/model/category/get/' + param,
		method: 'get'
	})
}

/**
 * 获取树形列表数据
 * @param query
 */
export function tree(query) {
	return request({
		url: '/api/rep/model/category/tree',
		method: 'get',
		data: query || {}
	})
}
